import { Box, Stack, Typography } from "@mui/material";
import React from "react";

const HeroSection = () => {
  return (
    <Box
      component="section"
      sx={{
        position: "relative",
        width: "100%",
        height: { xs: "500px", sm: "600px", md: "700px" },
        minHeight: { xs: "500px", sm: "600px", md: "700px" },
      }}
    >
      <Box
        sx={{
          height: "100%",
          width: "100%",
          backgroundImage: `url("/websiteAssets/AboutUsHeroSection.png")`,
          backgroundSize: "cover",
          backgroundPosition: { xs: "center", md: "50% 50%" },
          position: "relative",
        }}
      >
        <Box
          sx={{
            height: "100%",
            width: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.35)",
          }}
        />
      </Box>

      <Stack
        spacing={{ xs: 2.5, md: 3.25 }} // 50px
        sx={{
          position: "absolute",
          top: { xs: "50%", md: "250px" },
          left: { xs: "50%", md: "92px" },
          transform: {
            xs: "translate(-50%, -50%)",
            md: "translate(0, 0)",
          },
          width: "calc(100% - 48px)",
          maxWidth: { xs: "540px", md: "666px" },
          px: { xs: 2.5, md: 0 },
          textAlign: { xs: "center", md: "left" },
        }}
      >
        <Typography
          variant="h1"
          sx={{
            fontFamily: "Jost-Bold, Montserrat",
            fontWeight: 700,
            fontSize: { xs: "40px", sm: "48px", md: "64px" },
            letterSpacing: { xs: "-3px", md: "-7.68px" },
            color: "text.light",
            textShadow: "0px 4px 4px rgba(255, 255, 255, 0.25)",
            whiteSpace: { xs: "normal", md: "nowrap" },
          }}
        >
          OUR PRODUCTS
        </Typography>

        <Typography
          sx={{
            fontFamily: "Satoshi-Medium, Montserrat",
            fontWeight: 500,
            fontSize: { xs: "14px", sm: "15px", md: "16px" },
            color: "text.light",
            textShadow: "0px 4px 4px rgba(255, 255, 255, 0.25)",
            lineHeight: 1.7,
          }}
        >
          Our mission is to empower individuals by providing a secure platform
          to manage personal records and share profiles effortlessly with a
          single tap. We are committed to enhancing connectivity and simplifying
          access to essential information, making everyday interactions seamless
          and efficient.
        </Typography>

        {/* <Button
          variant="contained"
          sx={{
            width: "208px",
            height: "63px",
            mb: "-8px",
            backgroundColor: "#3f51b5",
            color: "white",
            fontWeight: "bold",
            "&:hover": {
              backgroundColor: "#1f164f",
            },
            textTransform: "uppercase",
          }}
        >
          Learn More
        </Button> */}
      </Stack>
    </Box>
  );
};

export default HeroSection;
